import React, { useState } from 'react';
import { SITE } from '../data/siteData';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './Gallery.css';
import img1 from '../assets/11.jpeg';
import img2 from '../assets/12.jpeg';
import img3 from '../assets/13.jpeg';
import Icon from '../components/Icon';
import img4 from '../assets/14.jpeg';
import img5 from '../assets/15.jpeg';
import img6 from '../assets/36.png';
import img7 from '../assets/54.jpeg';
import img8 from '../assets/3.jpeg';
import img9 from '../assets/4.jpeg';
import img10 from '../assets/5.jpeg';
import img11 from '../assets/6.jpeg';
import img12 from '../assets/7.jpeg';
import img13 from '../assets/64.jpeg';
import img14 from '../assets/9.jpeg';



const GALLERY_IMAGES = [
  {
    img: img1,
    title: 'DSP Mutual Fund Certificate of Appreciation',
    caption: 'Presented to Gandharv Mohanlal Narendra for their valuable contribution to the growth of our mutual fund business. Presented by Usha Nair, SVP, Head of Distribution Sales, DSP Mutual Fund.',
  },
  {
    img: img2,
    title: 'Bandhan Mutual Fund Top SIP Performer',
    caption: 'Recognized as Top SIP Performer - Gandharv Mohanlal Narendra achieved this milestone. Presented by Vishal Kapoor (CEO), Gaurab Parija (Head-Sales), and Kapil Kishore (Regional Head-South).',
  },
  {
    img: img3,
    title: 'Jaipur Recognition Certificate',
    caption: 'Awarded in recognition of the valuable contribution and participation in the Prudent Learning Conclave – May 2026, held in Jaipur, Rajasthan.',
  },
  {
    img: img4,
    title: 'Prime Circle - Lead the League Award',
    caption: 'Gandharv Mohanlal Narendra recognized as "Lead the League" at Hyderabad-Somajiguda Branch. Awarded for Naya Saal Naya Josh campaign. Date: JAN 2026..',
  },
  {
    img: img5,
    title: 'Prudent Fundbazar Star Performer',
    caption: 'Recognizing Excellence - Gandharv Mohanlal Narendra awarded as Star Performer at Hyderabad Somajiguda Branch. Naya Saal Naya Josh campaign - JAN 2025.',
  },
];

const ACHIEVEMENT_IMAGES = [
  {
    img: img6,
    title: 'Wealth Planning Seminar 2024',
  },
  {
    img: img7,
    title: 'Excellence Award Ceremony',
  },
  {
    img: img8,
    title: 'Client Appreciation Evening',
  },
  {
    img: img9,
    title: '25 Years of Advisory Excellence',
  },
  {
    img: img10,
    title: 'Investment Workshop — Hyderabad',
  },
  {
    img: img11,
    title: '1000+ Client Milestone',
  },
  {
    img: img12,
    title: 'Telangana Finance Excellence',
  },
  {
    img: img13,
    title: 'Financial Literacy Drive',
  },
  {
    img: img14,
    title: '₹100 Crore AUM',
  },
];

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null);
  const { ref: heroRef, visible: heroVis } = useScrollReveal();

  return (
    <div className="gallery-page page-wrapper">
      {/* Hero */}
      <div className="gallery-hero">
        <div className="gallery-hero-grid" />
        <div className="gallery-hero-glow" />
        <div className="gallery-hero-inner" ref={heroRef}>
          <div className={`section-label${heroVis ? ' reveal-visible' : ' reveal'}`}> <div id="green1">Achievements & Moments </div></div>
          <h1 className={`section-title${heroVis ? ' reveal-visible' : ' reveal'}`} style={{ transitionDelay: '0.1s' }}>
            Our Gallery
          </h1>
          <p className={`section-sub${heroVis ? ' reveal-visible' : ' reveal'}`} style={{ transitionDelay: '0.2s', maxWidth: 560, margin: '16px auto 0' }}>
            25+ years of milestones, awards, events, and moments that define our journey of growing wealth and building trust across India.
          </p>
        </div>
      </div>

      {/* Awards & Achievements - 9 Images Grid */}
      <section className="gallery-achievements">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <div className="section-label" style={{ justifyContent: 'center' }}>Recognition & Milestones</div>
            <h2 className="section-title" style={{ textAlign: 'center' }}>
              Moments That <span className="green">Matter</span>
            </h2>
          </div>
          <div className="achievement-grid-9">
            {ACHIEVEMENT_IMAGES.map((item, i) => {
              const { ref, visible } = useScrollReveal();
              return (
                <div
                  key={i}
                  ref={ref}
                  className={`achievement-image-card${visible ? ' visible' : ''}`}
                  style={{ transitionDelay: `${(i % 3) * 0.1}s` }}
                  onClick={() => setLightbox(item)}
                >
                  <div className="ach-img-wrap">
                    <img src={item.img} alt={item.title} className="ach-img" loading="lazy" />
                    {/* <div className="ach-overlay">
                      <div className="ach-zoom">🔍</div>
                      <div className="ach-img-title">{item.title}</div>
                    </div> */}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Photo Gallery - 5 Horizontal Images */}
      <section className="gallery-photos">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <div className="section-label" style={{ justifyContent: 'center' }}>Photo Gallery</div>
            <h2 className="section-title" style={{ textAlign: 'center' }}>
              Awards & <span className="green">Achievements</span>
            </h2>
          </div>

          {/* Horizontal Grid */}
          <div className="gallery-horizontal">
            {GALLERY_IMAGES.map((item, i) => {
              const { ref, visible } = useScrollReveal();
              return (
                <div
                  key={i}
                  ref={ref}
                  className={`gallery-horizontal-item${visible ? ' visible' : ''}`}
                  style={{ transitionDelay: `${i * 0.1}s` }}
                  onClick={() => setLightbox(item)}
                >
                  <div className="ghi-img-wrap">
                    <img src={item.img} alt={item.title} className="ghi-img" loading="lazy" />
                    {/* <div className="ghi-overlay">
                      <div className="ghi-zoom">🔍</div>
                    </div> */}
                  </div>
                  <div className="ghi-body">
                    <div className="ghi-title">{item.title}</div>
                    <div className="ghi-caption">{item.caption}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div className="lightbox" onClick={() => setLightbox(null)}>
          <div className="lightbox-inner" onClick={e => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setLightbox(null)}>✕</button>
            <img src={lightbox.img} alt={lightbox.title} className="lightbox-img" />
            <div className="lightbox-info">
              <div className="lightbox-title">{lightbox.title}</div>
              {lightbox.caption && <div className="lightbox-caption">{lightbox.caption}</div>}
            </div>
          </div>
        </div>
      )}

      {/* CTA */}
      <section className="gallery-cta">
        <div className="container" style={{ textAlign: 'center', padding: '80px 24px' }}>
          <h2 className="section-title">
            Be Part of Our <span className="green">Success Story</span>
          </h2>
          <p className="section-sub" style={{ margin: '16px auto 40px', maxWidth: 480 }}>
            Join 1000+ families who have trusted LMS Marketing & Services for their financial journey since 2000.
          </p>
          <a href={`tel:${SITE.contact.phone}`} className="btn-primary">
            📞 Start Your Journey → {SITE.contact.phone}
          </a>
        </div>
      </section>
    </div>
  );
}